import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';

import classes from './RootErrorBoundary.module.css';

export function RootErrorBoundary({ children }: React.PropsWithChildren) {
  return <ErrorBoundary FallbackComponent={RootErrorComponent}>{children}</ErrorBoundary>;
}

export function RootErrorComponent({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div className={classes.error}>
      <h1>An application error has occurred.</h1>
      <div className={classes.message}>
        <strong>{error.name}:</strong> {error.toString()}
        {!!error.stack && (
          <>
            <div className={classes.location}>
              In <code>{error.fileName}</code> at line {error.lineNumber}:{error.columnNumber}
            </div>
            <pre>{error.stack}</pre>
          </>
        )}
      </div>
      {import.meta.env.DEV && false && (
        <>
          <button type="button" onClick={resetErrorBoundary}>
            Reset
          </button>
          <button type="button" onClick={() => window.location.reload()}>
            Refresh Page
          </button>
        </>
      )}
    </div>
  );
}
